import { Component, OnInit, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-emesent',
  templateUrl: './emesent.component.html',
  styleUrls: ['./emesent.component.scss'],
})

export class EmesentComponent implements OnInit {
  listImagenes: string[] = [
    "../../../../assets/img/SOLUCIÓN/carusel/lidar_1.png",
  ];
  slides = [
    { desktopImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_1.png", mobileImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_1.png" },
    { desktopImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_2.png", mobileImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_2.png" },
    { desktopImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_3.png", mobileImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_3.png" },
    { desktopImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_4.png", mobileImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_4.png" },
    { desktopImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_5.png", mobileImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_5.png" },
    { desktopImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_6.png", mobileImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_6.png" },
    { desktopImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_7.png", mobileImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_7.png" },
    { desktopImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_8.png", mobileImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_8.png" },
    { desktopImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_9.png", mobileImage: "../../../../assets/img/SOLUCIÓN/carusel/lidar_9.png" },

  ];

  slidesToShow = 2;
  screenWidth: number;
  constructor(public dialog: MatDialog) {
    this.onResize();
  }
  @HostListener('window:resize', [])
  onResize() {
    this.screenWidth = window.innerWidth;
    this.slidesToShow = this.screenWidth < 768 ? 1 : 2;
  }

  getImage(slide: { desktopImage: string, mobileImage: string }) {
    return this.screenWidth < 768 ? slide.mobileImage : slide.desktopImage;
  }
  ngOnInit(): void {
  }

}
